import React from "react";
import "./DroneMap.css";
// Remove these incorrect imports
// import mapImage from "../../public/dronemap.png";
// import forestImage from "../../public/forest.png";

const zones = [
  { 
    name: "Test Zone A", 
    size: "52 km",
    imageUrl: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e"
  },
  { 
    name: "Test Zone B", 
    size: "48 km",
    imageUrl: "https://images.unsplash.com/photo-1472396961693-142e6e269027"
  },
  { 
    name: "Test Zone C", 
    size: "55 km",
    imageUrl: "/zone-c.jpg"
  },
  { 
    name: "Test Zone D", 
    size: "51 km",
    imageUrl: "/zone-d.jpg"
  },
];

export default function DroneMap() {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/dronemap.png"; // Use public URL path
    link.download = "Udawalawe-National-Park-Map.jpg"; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="page-container">
      <div className="drone-map-wrapper">
      {/* Left Side - Map */}
      <div className="drone-map-card">
        <div className="card-header">
          <h2 className="title">Udawalawe National Park</h2>
          <button className="download-btn" onClick={handleDownload}>
            📥 Download
          </button>
        </div>
       
        <img src="/dronemap.png" alt="Udawalawe National Park Map" className="map-image" />
      </div>

      {/* Right Side - Test Zones */}
      <div className="test-zones-card">
        <div className="zones-header">
          <h2>Test Zones</h2>
          <span>Total Coverage: 330 km</span>
        </div>
        <div className="zones-grid">
          {zones.map((zone, index) => (
            <div className="zone-card" key={index}>
              <img src={zone.imageUrl} alt={zone.name} className="zone-image" />
              <div className="zone-info">
                <span className="zone-name">{zone.name}</span>
                <span className="zone-size">Size: {zone.size}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

    </div>
  );
}